ko.bindingHandlers.tinymce = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        const minHeight = ko.unwrap(allBindingsAccessor.get('minHeight'));

        tinymce.init({
            target: element,
            menubar: false,
            statusbar: false,
            toolbar: 'formatselect fontsizeselect | ' +
                'bold italic underline | forecolor backcolor | ' +
                'alignleft aligncenter alignright alignjustify | link image media | bullist numlist outdent indent | ' +
                'removeformat',
            plugins: 'autoresize pflink image media lists paste',
            link_class_list: [
                { title: 'Show as Link', value: '' },
                { title: 'Show as Button', value: 'productfruits--link-appearance-btn-primary' },
                //{ title: 'Show as Secondary Button', value: 'productfruits--link-appearance-btn-secondary' },
            ],
            link_title: false,
            setup: function (editor) {
                editor.on('Change', function (e) {
                    valueAccessor()(editor.getContent());
                    document.dispatchEvent(new CustomEvent('changelog_editor_onchange'));
                });

                editor.on('init', function (e) {
                    editor.setContent(ko.unwrap(valueAccessor()));
                });
            },
            image_title: false,
            image_description: false,
            image_dimensions: false,
            images_file_types: 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp,svg',
            file_picker_types: 'image',
            images_upload_handler: image_upload_handler,
            min_height: minHeight ? minHeight : 350,
            max_height: 800,
            content_css: '/css/tinymce.css',
            object_resizing: false,
            fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 24pt 30pt 36pt 42pt',
        });

        //const updateFromModel = async function () {
        //    var val = ko.unwrap(valueAccessor());

        //    tinymce.activeEditor.setContent(val);
        //};

        //ko.computed(updateFromModel, null, { disposeWhenNodeIsRemoved: element });
        const h = (e) => {
            tinymce.activeEditor.setContent(ko.unwrap(e.detail.content) || '');
        };
        document.addEventListener('tiny_should_change', h);
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            document.removeEventListener('tiny_should_change', h);
        });
    },
    update: function (element, valueAccessor) {
        //const currValue = (tinymce.activeEditor.getContent() || '');
        //const newVal = (ko.unwrap(valueAccessor()) || '')

        //if (currValue != newVal) {
        //    tinymce.activeEditor.setContent(newVal);
        //}
    }
};

function image_upload_handler(blobInfo, success, failure, progress) {
    var xhr, formData;

    xhr = new XMLHttpRequest();
    xhr.open('POST', `/files/${window.auth.project.UniqueCode}`);
    xhr.upload.onprogress = function (e) {
        progress(e.loaded / e.total * 100);
    };
    xhr.onload = function () {
        var json;

        if (xhr.status === 403) {
            failure('HTTP Error: ' + xhr.status, { remove: true });
            return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
            failure('HTTP Error: ' + xhr.status);
            return;
        }

        json = JSON.parse(xhr.responseText);

        if (!json || typeof json.fileId != 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
        }

        success('https://cdn-assets.productfruits.com/' + json.fileId);
    };
    xhr.onerror = function () {
        failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
    };

    formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());

    xhr.send(formData);
};
